module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Medium.c88bc69d.eot";